
















import { Vue, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { Organization } from '@models';

@Component
export default class OrgList extends Vue {
  name = 'org-list';
  @Prop(Array) readonly organizations!: Organization[];
}
